import { render, staticRenderFns } from "./ProductsGallery.vue?vue&type=template&id=1c641376&scoped=true&"
import script from "./ProductsGallery.vue?vue&type=script&lang=js&"
export * from "./ProductsGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductsGallery.vue?vue&type=style&index=0&id=1c641376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c641376",
  null
  
)

export default component.exports